import { useQuery } from "@tanstack/react-query"
import { campaignsQuery } from "../lib/campaignsQuery"

export function useCampaignsQuery(...args: Parameters<typeof campaignsQuery>) {
  return useQuery(campaignsQuery(...args))
}
